'use client';

import { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import { MonitorIcon, MoonIcon, SunIcon } from '@phosphor-icons/react';
import { cn } from '@/lib/shadcn/utils';

interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  // SSR cannot read localStorage. Keep the first client render identical,
  // then show the selected theme after hydration (next-themes guidance).
  const selectedTheme = mounted ? theme : undefined;

  return (
    <div
      className={cn(
        'text-foreground bg-background flex flex-row divide-x overflow-hidden rounded-full border shadow-sm',
        className
      )}
    >
      <span className="sr-only">Тема оформления</span>
      <button
        type="button"
        onClick={() => setTheme('dark')}
        aria-label="Тёмная тема"
        aria-pressed={selectedTheme === 'dark'}
        className="hover:bg-accent focus-visible:ring-ring flex size-10 cursor-pointer items-center justify-center focus-visible:ring-2 focus-visible:ring-inset"
      >
        <MoonIcon
          size={16}
          weight="bold"
          className={cn(selectedTheme !== 'dark' && 'opacity-25')}
        />
      </button>
      <button
        type="button"
        onClick={() => setTheme('light')}
        aria-label="Светлая тема"
        aria-pressed={selectedTheme === 'light'}
        className="hover:bg-accent focus-visible:ring-ring flex size-10 cursor-pointer items-center justify-center focus-visible:ring-2 focus-visible:ring-inset"
      >
        <SunIcon
          size={16}
          weight="bold"
          className={cn(selectedTheme !== 'light' && 'opacity-25')}
        />
      </button>
      <button
        type="button"
        onClick={() => setTheme('system')}
        aria-label="Системная тема"
        aria-pressed={selectedTheme === 'system'}
        className="hover:bg-accent focus-visible:ring-ring flex size-10 cursor-pointer items-center justify-center focus-visible:ring-2 focus-visible:ring-inset"
      >
        <MonitorIcon
          size={16}
          weight="bold"
          className={cn(selectedTheme !== 'system' && 'opacity-25')}
        />
      </button>
    </div>
  );
}
